import type { GenerationResult } from '../../lib/api/quality-types.js';

export function retainedGenerationWarning(result?: GenerationResult) {
  return result &&
    ['ready', 'saved'].includes(result.state) &&
    result.severity === 'warning' &&
    result.retained_case_count > 0
    ? result.message
    : null;
}

export function GenerationResultFeedback({
  result,
}: {
  result?: GenerationResult;
}) {
  if (!result?.message) return null;
  if (retainedGenerationWarning(result)) return null;
  return (
    <div
      role={result.severity === 'info' ? 'status' : 'alert'}
      className={
        result.severity === 'error'
          ? 'rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm'
          : 'rounded-lg border border-amber-500/30 bg-amber-500/5 p-4 text-sm'
      }
    >
      <p className="font-medium">
        {result.state === 'publishing'
          ? 'Publication is in progress'
          : result.state === 'publication_unresolved'
            ? 'Publication needs attention'
            : result.severity === 'warning'
              ? 'Generated cases are available with warnings'
              : result.severity === 'error'
                ? 'Generation could not complete'
                : 'Generation result'}
      </p>
      <p>{result.message}</p>
    </div>
  );
}
